export const AppConfig = {
  appName: 'Shopify Connect',
  apiBaseUrl: 'https://shopifyconnectapi.bezohminds.app/',
  theme: {
    primaryColor: '#00b0ff',
    accentColor: '#ff4081',
    successColor: '#00e676',
    warningColor: '#ffab00',
    errorColor: '#ff1744',
    infoColor: '#00b0ff'
  },
  pagination: {
    pageSize: 10
  },
  statuses: {
    synced: 'Synced',
    pending: 'Pending',
    failed: 'Failed'
  }
};
